import React, { useEffect, useState } from "react";
import Section from "../layouts/Section";
import { NavLink, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { servicePath } from "../../constants/defaultsValues";

// const goBack = () => {
//   useHistory.goBack();
// };
/* VALIDATIONS */
const validatePassword = (value) => {
  let error = null;
  if (!value) {
    error = "Campo obligatorio";
  } else if (value.length < 6) {
    error = "Password debe ser mayor a 6 caracteres";
  }
  return error;
};
/* END VALIDATIONS */
const ResetPassword = (jwt) => {
  const history = useHistory();
  const { token } = useParams();
  const [user, setUser] = useState(null);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [errors, setErrors] = useState({ password: null, username: null });

  const userFetch = async () => {
    axios
      .post(
        `${servicePath}/residents/new/confirm`,
        {
          token,
        },
      )
      .then((res) => {
        setUser(res.data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (token) {
      userFetch();
    }
  }, []);

  useEffect(() => {
    localStorage.clear();
  }, []);

  const validateReset = () => {
    const validPass = validatePassword(password);
    const validPassConfirm = validatePassword(passwordConfirm);
    setErrors({
      password: validPass,
      passwordConfirm: validPassConfirm,
    });
    return !validPass && !validPassConfirm;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const valid = validateReset();
    if (valid) {
        axios
          .post(
            `${servicePath}/residents/update-password`,
            {
              userId: user,
              password: password,
            },
          )
          .then(() => {
            history.push('/login');
          })
          .catch((err) => {
            console.log(err);
          });
    }
  };

  // if (jasonWebToken !== null) {
  //   return <Redirect to="/">Error, ya hay una cuenta iniciada</Redirect>;
  // } else {
    return (
      <Section
        allNotification={false}
        searchPopup={true}
        title={"Login"}
        disabledHeader={true}
        disabledFooter={true}
      >
        <section
          className="section-login"
          style={{
            backgroundImage:
              "url(" +
              process.env.PUBLIC_URL +
              "/assets/img/Fondo-login.png" +
              ")",
              height: '1000px',
          }}
        >
          <div className="page-title bg-transparent">
            {/* <div className="container pt-3">
              <button
                className="text-left home-clicked go-back"
                onClick={goBack}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-chevron-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                  />
                </svg>
              </button>
            </div> */}
          </div>
          <div className="text-center mg-bottom-40 title">
            <div className="col-md-4 col-5 mx-auto mb-5">
              <img
                src={process.env.PUBLIC_URL + "/assets/img/civity-logo.svg"}
                alt="civity"
              />
            </div>
            <div className="col-12 text-center">
              <h4 className="text-center">Establece una nueva contraseña</h4>
            </div>
          </div>
          <div className="Login-area">
            <div className="container">
              <form className="contact-form-inner bg-transparent">
                {jwt.message ? (
                  <div className="col-12 text-center mx-auto mb-3">
                    <span className="text-danger mx-auto">{jwt.message}</span>
                  </div>
                ) : null}
                <label className="single-input-wrap">
                  <input
                    type="password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    placeholder="Contraseña"
                  />
                  {errors.password ? (
                    <span className="text-danger">{errors.password}</span>
                  ) : null}
                </label>
                <label className="single-input-wrap">
                  <input
                    type="password"
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                    value={passwordConfirm}
                    placeholder="Confirmar contraseña"
                  />
                  {errors.password ? (
                    <span className="text-danger">{errors.password}</span>
                  ) : null}
                </label>
                <NavLink to="/login">
                <div className="text-right">
                  <span>¿Ya tienes una cuenta? Inicia Sesión</span>
                  </div>
                </NavLink>
                <div className="w-100 text-center">
                  <button
                    className="btn btn-login mx-auto"
                    onClick={(e) => onSubmit(e)}
                  >
                    Establecer contraseña
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </Section>
    );
  // }
};

// const mapStateToProps = (state) => {
//   return {
//     jwt: state.jwt,
//     message: state.error,
//   };
// };

// export default connect(mapStateToProps, { resetPasswordAction: resetPasswordStart })(
//   ResetPassword
// );

export default ResetPassword;
